module.exports = __webpack_public_path__ + "static/media/laserbeam2.1611bdd4.png";